import { AxisOptions, Options } from 'highcharts/highstock';

export const addAdminOnlyOptions = (options: Options) => {
    if (!options.yAxis) return;
    // Sorry, I don't know of a better way to make Typescript accept this:
    const yAxis = options.yAxis as AxisOptions[];
    yAxis.push({
        id: 'battery',
        title: {
            text: null,
        },
        labels: {
            format: '{value}',
            x: 20,
        },
        height: '25%',
        top: '40%',
        min: -2,
        max: 2,
        showFirstLabel: false,
        showLastLabel: false,
        opposite: false,
    });
    yAxis.push({
        id: 'voltage',
        title: {
            text: null,
        },
        labels: {
            format: '{value}v',
            x: -20,
        },
        height: '25%',
        top: '40%',
        showFirstLabel: false,
        showLastLabel: false,
        opposite: true,
    });
};
